import { axiosService } from "service"
import { plantStationEndpoints } from "service/sources/plant/Station"

const list = (options) => {
  return axiosService.get(plantStationEndpoints.LIST + options)
}

const searchVehicle = (search) => {
  return axiosService.get(
    plantStationEndpoints.SEARCH_VEHICLE + `?search=${search}`
  )
}

const uploadPhoto = (empresa, id, files, initialName) => {
  return axiosService.uploadFiles(
    plantStationEndpoints.PHOTO + id + "?empresa=" + empresa,
    files,
    initialName
  )
}

const createStock = (id, body) => {
  return axiosService.post(plantStationEndpoints.CREATE_STOCK + id, body)
}

const editItem = (id, body) => {
  return axiosService.put(plantStationEndpoints.EDIT_ITEM + id, body)
}

const deletePhoto = (body) => {
  return axiosService.post(plantStationEndpoints.DELETE_PHOTO, body)
}

export const plantStation = {
  list,
  searchVehicle,
  uploadPhoto,
  createStock,
  editItem,
  deletePhoto
}
